/**
 * Notification Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationRuleDto { 
    id?: number;
    collarId?: number;
    notificationAddressId?: number;
    notificationAddressValue?: string;
    notificationAddressType?: NotificationRuleDto.NotificationAddressTypeEnum;
    activity?: boolean;
    gpsPosition?: boolean;
    gsmQuality?: boolean;
    mortality?: boolean;
    mortalityImplant?: boolean;
    proximity?: boolean;
    separation?: boolean;
    trapEvent?: boolean;
    vaginalImplant?: boolean;
    virtualFence?: boolean;
    command?: boolean;
}
export namespace NotificationRuleDto {
    export const NotificationAddressTypeEnum = {
        Email: 'EMAIL',
        FirebaseToken: 'FIREBASE_TOKEN',
        Sms: 'SMS',
        Telegram: 'TELEGRAM',
        Whatsapp: 'WHATSAPP',
        Webhook: 'WEBHOOK'
    } as const;
    export type NotificationAddressTypeEnum = typeof NotificationAddressTypeEnum[keyof typeof NotificationAddressTypeEnum];
}


export type NotificationAddressTypeEnum = typeof NotificationRuleDto.NotificationAddressTypeEnum[keyof typeof NotificationRuleDto.NotificationAddressTypeEnum];
